




import MemberBulkCreate from '@/components/Templates/Admin/Community/MemberBulkCreate/MemberBulkCreate.vue';

export default {
    name: 'CoAdminMembersBulkCreate',
    components: {
        MemberBulkCreate,
    },
};
